<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.pay02Title') }}</h1>
    </header>

    <div class="rb-pay-processing" role="status" aria-live="polite">
      <div class="rb-pay-orb" aria-hidden="true"></div>
      <p class="rb-match-outcome-body">{{ statusMessage || $t('intake.pay02Body') }}</p>
    </div>

    <div class="rb-ob-actions">
      <p class="rb-ob-status" role="status" aria-live="polite">{{ statusMessage }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {loadIntake, saveIntake} from '@/intake/intakeState'
import {
  getActiveBooking,
  isMatchmakingV2ApiEnabled,
  isMockCheckoutForced,
  paymentReturn,
} from '@/intake/sandboxMatchApi'
import {loadMatchSession, saveMatchSession} from '@/intake/sandboxMatchSession'
import {bookingReturnIdentifiers, routeForClientStatus as mapPayReturnRoute} from '@/intake/bookingPayRouting'

/**
 * Gateway redirect landing. Resolves booking state from the server only —
 * never trusts query.status / client-declared payment success.
 */
export default {
  name: 'MatchPayReturnStep',
  data() {
    return {
      statusMessage: '',
      resolving: false,
    }
  },
  created() {
    this.resolveReturn()
  },
  methods: {
    routeForClientStatus(status, bookingId) {
      return mapPayReturnRoute(status, bookingId)
    },
    resolveReturn() {
      if (this.resolving) {
        return
      }
      this.resolving = true
      const lang = this.$route.params.lang || 'fa'
      const q = this.$route.query || {}
      const draft = loadIntake()
      const session = loadMatchSession() || {}
      const body = bookingReturnIdentifiers(q, draft, session)
      const bookingId = body.booking_id || ''

      if (!isMatchmakingV2ApiEnabled() || isMockCheckoutForced()) {
        this.$router.replace({
          name: 'intakePayProcessing',
          params: {lang},
          query: bookingId ? {bookingId, demo: q.demo} : {demo: q.demo || 'success'},
        })
        return
      }

      const finish = (data) => {
        const id = (data && data.booking_id) || bookingId
        if (id) {
          saveIntake({bookingId: id, bookingCode: (data && data.booking_code) || draft.bookingCode})
          saveMatchSession({bookingId: id, bookingCode: data && data.booking_code})
        }
        const status = (data && (data.client_status || data.state)) || 'PROCESSING'
        const dest = this.routeForClientStatus(status, id)
        if (dest.paymentOutcome) {
          saveIntake({paymentOutcome: dest.paymentOutcome})
        }
        this.$router.replace({
          name: dest.name,
          params: {lang},
          query: dest.query || {},
        })
      }

      const run = body.booking_id || body.payment_id || body.cart_id
        ? paymentReturn(body)
        : getActiveBooking().then((active) => {
          if (active && active.booking) {
            return active.booking
          }
          throw Object.assign(new Error('NO_ACTIVE_BOOKING'), {code: 'BOOKING_NOT_FOUND'})
        })

      run.then(finish).catch(() => {
        this.statusMessage = this.$t('intake.formIncomplete')
        this.$router.replace({
          name: 'intakePayProcessing',
          params: {lang},
          // Keep the failed callback's exact identifiers available for retry.
          query: Object.assign({}, body.payment_id ? {payment_id: body.payment_id} : {}, body.cart_id ? {cart_id: body.cart_id} : {}, bookingId ? {bookingId} : {}),
        })
      }).finally(() => {
        this.resolving = false
      })
    },
  },
}
</script>
